<template>
<div :class="['pt-3', 'px-4', isNavigating ? 'page-fade-out' : 'page-fade-in']">
    <b-row class="mb-4 pl-2">
    <b-button variant="link" class="text-secondary p-0 btn-back" @click="goBack" :disabled="isNavigating">
        <b-spinner v-if="isNavigating" small class="mr-1"></b-spinner>
        <font-awesome-icon v-else :icon="['fas', 'search']" class="mr-1 transition-icon" /> Volver al índice
    </b-button>
    </b-row>
    <b-row v-if="loading" class="pl-2 mt-5">
    <b-col cols="12" class="text-center text-info my-5">
        <b-spinner class="align-middle"></b-spinner>
        <strong class="ml-2">Cargando detalles del color...</strong>
    </b-col>
    </b-row>
    <b-row v-else-if="!colorData && !loading" align-h="center" class="mt-5">
    <div class="text-center text-danger">
        <font-awesome-icon :icon="['far', 'info-circle']" size="2x" class="mb-2" />
        <h5>Color no encontrado</h5>
    </div>
    </b-row>
    <b-row v-else class="pl-2">
    <b-col lg="7" xl="6">
        <b-card no-body class="shadow-sm overflow-hidden border-0 elegant-card">
        <b-row no-gutters>
            <!-- Preview dinámico: Muestra color sólido si tiene Hex, o la imagen local si es Jaspe -->
            <b-col md="4" class="d-flex align-items-center justify-content-center bg-light p-3 border-right">
            <div v-if="colorData.hex_code" :class="['color-preview-box', colorData.tipo_acabado === 'Satinado' ? 'finish-satin' : 'finish-matte']" :style="{ backgroundColor: formatHex(colorData.hex_code) }"></div>
            <b-img v-else :src="getJaspeImagePath(colorData.name)" fluid class="color-preview-img rounded shadow-sm" @error="onImgError" />
            </b-col>
            <b-col md="8">
            <b-card-body class="py-4">
                <h3 class="font-weight-bold text-dark mb-1">{{ colorData.name }}</h3>
                <b-badge :variant="colorData.tipo_acabado === 'Satinado' ? 'info' : 'dark'" class="mb-3 px-2 py-1 fs-12 shadow-sm">{{ colorData.tipo_acabado || 'N/A' }}</b-badge>
                <table class="table table-sm table-borderless fs-14 mt-2 mb-0">
                <tbody>
                    <tr>
                    <td class="font-weight-bold text-secondary" style="width: 120px;">ID Sistema:</td>
                    <td class="text-dark">#{{ colorData.id }}</td>
                    </tr>
                    <tr v-if="colorData.ral_code">
                    <td class="font-weight-bold text-secondary">Código RAL:</td>
                    <td class="text-dark">
                        {{ colorData.ral_code }}
                        <b-badge variant="light" class="border cursor-pointer ml-1 text-muted hover-copy" @click="copyText(colorData.ral_code, 'Código RAL')">Copiar</b-badge>
                    </td>
                    </tr>
                    <tr v-if="colorData.hex_code">
                    <td class="font-weight-bold text-secondary">Código Hex:</td>
                    <td>
                        <code>{{ colorData.hex_code }}</code>
                        <b-badge variant="light" class="border cursor-pointer ml-1 text-muted hover-copy" @click="copyText(colorData.hex_code, 'Código Hex')">Copiar</b-badge>
                    </td>
                    </tr>
                    <tr v-if="colorData.hex_code">
                    <td class="font-weight-bold text-secondary">RGB Aprox:</td>
                    <td class="text-dark">{{ hexToRgb(colorData.hex_code) }}</td>
                    </tr>
                    <tr>
                    <td class="font-weight-bold text-secondary">Estado:</td>
                    <td class="text-success font-weight-bold">
                        <font-awesome-icon :icon="['fas', 'dot-circle']" class="fs-10 mr-1" style="font-size: 8px;" />{{ colorData.status === 'Activo' ? 'Activo' : 'Inactivo' }}
                    </td>
                    </tr>
                </tbody>
                </table>
                <div v-if="colorData.samples && colorData.samples.length > 0" class="mt-4 pt-3 border-top">
                <p class="font-weight-bold text-secondary mb-2 fs-14">Imágenes de Muestra ({{ colorData.samples.length }})</p>
                <div class="d-flex flex-wrap">
                    <div v-for="sample in colorData.samples" :key="sample.id" class="mr-2 mb-2 border rounded p-1 shadow-sm text-center image-thumbnail" @click="openImageModal(sample)">
                    <b-img :src="sample.img_url_lg" fluid class="mb-1 rounded" style="max-height: 50px; object-fit: cover;" />
                    <p class="fs-10 text-muted m-0 text-truncate" style="max-width: 60px;">{{ sample.caption || 'Muestra' }}</p>
                    </div>
                </div>
                </div>
            </b-card-body>
            </b-col>
        </b-row>
        </b-card>
    </b-col>
    </b-row>
    <b-modal v-model="isModalOpen" hide-footer centered size="lg" :title="selectedSample ? (selectedSample.caption || 'Muestra de Color') : ''" header-bg-variant="light">
    <div class="text-center" v-if="selectedSample">
        <b-img :src="selectedSample.img_url_lg" fluid class="rounded shadow-sm" style="max-height: 75vh; object-fit: contain;" />
    </div>
    </b-modal>
</div>
</template>
<script>
export default {
name: 'ColorShow',
data() {
    return {
    colorData: null,
    loading: true,
    isNavigating: false,
    isModalOpen: false,
    selectedSample: null
    };
},
mounted() {
    this.fetchColorDetails();
},
methods: {
    fetchColorDetails() {
    this.loading = true;
    const colorId = this.$route.params.id;
    this.$http.get(`/api/production/colors/${colorId}`).then(response => {
        this.colorData = response.data;
    }).catch(error => {
        console.error(error);
    }).finally(() => {
        this.loading = false;
    });
    },
    goBack() {
    this.isNavigating = true;
    setTimeout(() => {
        this.$router.push('/app/prod/colores');
    }, 350);
    },
    openImageModal(sample) {
    this.selectedSample = sample;
    this.isModalOpen = true;
    },
    getJaspeImagePath(name) {
    if (!name) return '/images/thumb/missing.png';
    const firstWord = name.trim().toUpperCase().split(' ')[0];
    return `/images/colors/${firstWord}.png`;
    },
    onImgError(event) {
    event.target.src = '/images/thumb/missing.png';
    },
    copyText(text, label) {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
        this.$bvToast.toast(`${text}`, {
        title: `${label} copiado exitosamente`,
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-bottom-right',
        autoHideDelay: 2500
        });
    });
    },
    formatHex(val) {
    if (!val) return 'transparent';
    return val.toString().startsWith('#') ? val : '#' + val;
    },
    hexToRgb(hex) {
    if (!hex) return 'N/A';
    let cleanHex = hex.toString().startsWith('#') ? hex.slice(1) : hex;
    let result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(cleanHex);
    return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : 'N/A';
    }
}
};
</script>
<style scoped>
.cursor-pointer { cursor: pointer; }
.elegant-card { border-radius: 10px; border: 1px solid rgba(0,0,0,0.05) !important; }
.color-preview-box { width: 120px; height: 180px; border-radius: 8px; border: 1px solid rgba(0,0,0,0.1); }
.color-preview-img { width: 120px; height: 180px; object-fit: cover; border-radius: 8px; border: 1px solid rgba(0,0,0,0.1); }
.finish-satin { background-image: linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 50%, rgba(0,0,0,0.1) 100%); box-shadow: inset -5px 0px 15px rgba(0,0,0,0.1), inset 5px 5px 15px rgba(255,255,255,0.5) !important; }
.finish-matte { background-image: none; box-shadow: inset -5px 0px 15px rgba(0,0,0,0.15) !important; }
.btn-back { text-decoration: none !important; transition: color 0.2s; font-size: 14px; font-weight: 500; }
.btn-back:hover { color: #343a40 !important; }
.transition-icon { transition: transform 0.2s ease; }
.page-fade-in { opacity: 1; transform: translateY(0); transition: opacity 0.35s ease, transform 0.35s ease; }
.page-fade-out { opacity: 0; transform: translateY(15px); transition: opacity 0.35s ease, transform 0.35s ease; pointer-events: none; }
.image-thumbnail { cursor: pointer; transition: transform 0.2s, box-shadow 0.2s; }
.image-thumbnail:hover { transform: scale(1.05); box-shadow: 0 .25rem .5rem rgba(0,0,0,.15) !important; }
.hover-copy { transition: all 0.2s ease; }
.hover-copy:hover { background-color: #6c757d !important; color: white !important; }
</style>